import { useSectionData } from '../../../hooks/useSectionData';
import { useConfiguration } from '../../../../../../store/configurationStore';
import { SingleColumnWithLabelSectionProps } from './types';
import { Label } from '../../../types';

export const useSingleColumnWithLabelSection = (
  props: SingleColumnWithLabelSectionProps
) => {
  const { templateId, instrumentType, sectionId } = props;

  const { addTransferLabel, removeTransferLabel } = useConfiguration();

  // Get section data using shared hook
  const { section, selectedColumn, validationResult } = useSectionData({
    templateId,
    instrumentType,
    sectionId,
  });

  // Extract labels from section
  const labels = section?.config.labels || [];

  const handleAddTransferLabel = (value: string) => {
    // Trim the input value
    const trimmedValue = value.trim();

    // Check if trimmed value is empty
    if (!trimmedValue) {
      throw new Error('⚠️ Label value cannot be empty');
    }

    // Check if label already exists (case-insensitive)
    const isDuplicate = labels.some(
      label => label.value.toLowerCase() === trimmedValue.toLowerCase()
    );

    if (isDuplicate) {
      throw new Error(`⚠️ Label "${trimmedValue}" already exists`);
    }

    // Create and add label (store reads current state)
    const newLabel: Label = {
      id: `label-${Date.now()}-${Math.random()}`,
      value: trimmedValue,
    };
    addTransferLabel(templateId, instrumentType, sectionId, newLabel);
  };

  const handleRemoveTransferLabel = (labelId: string) => {
    removeTransferLabel(templateId, instrumentType, sectionId, labelId);
  };

  return {
    labels,
    selectedColumn,
    handleAddTransferLabel,
    handleRemoveTransferLabel,
    validationResult,
  };
};
